<template>
  <div class="columns is-centered">
    <div class="column is-two-thirds-tablet is-half-desktop">
      <user-type-tabs
        :values="tabs.values"
        :labels="tabs.labels"
        :active-tab="tabs.activeTab"
        :activate-tab="activateTab"
      />
      <div v-if="tabs.activeTab === 'journeys'">
        <journeys-user-login />
      </div>
      <div v-if="tabs.activeTab === 'business'">
        <business-user-login @login-success="loginSuccess" />
      </div>
    </div>
  </div>
</template>

<script>
import Http from 'services/Http';
import { defaultAuthState } from 'utils/auth';

import BusinessUserLogin from 'components/auth/BusinessUserLogin';
import JourneysUserLogin from 'components/auth/JourneysUserLogin';
import UserTypeTabs from 'components/auth/UserTypeTabs';

export default {
  components: {
    BusinessUserLogin,
    JourneysUserLogin,
    UserTypeTabs,
  },

  data() {
    return defaultAuthState();
  },

  methods: {
    async loginSuccess({ token, refreshToken, userId }) {
      const redirectTo = this.$route.query.redirectTo;

      Http.setToken(token);
      Http.setRefreshToken(refreshToken);
      Http.setUserType('business');

      await this.$store.dispatch('account/init', userId);

      if (redirectTo === 'graphql') {
        window.location = '/graphql';
      } else if (!!redirectTo) {
        this.$router.push({ path: redirectTo });
      } else {
        this.$router.push('apps');
      }
    },

    activateTab(tabName) {
      if (tabName !== this.tabs.activeTab) {
        this.tabs.activeTab = tabName;

        this.$router.push({ query: { tab: tabName } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';
</style>
